import React from 'react';
import {useMenu} from '../../../../../hooks/useMenu';
import ProgressBarView from '../../../../views/progressbarView';
import FlowInstallationFinished from './installation-finished';

function InstallationFlowPB() {
  const {onComponent} = useMenu();
  return (
    <ProgressBarView
      title="Installation Verification"
      content="Verifying Installation"
      onExit={() => onComponent(<FlowInstallationFinished />)}
    />
  );
}

export default InstallationFlowPB;
